/**
 * The Color — free travel size on orders of £40+ (owner, 4 Nov 2026).
 * Gift theme only. Loaded by snippets/tc-gift40.liquid (part 'boot') while the
 * offer runs; removes everything it added at window.TC_GIFT40.end.
 *
 * The offer is Shopify's automatic Buy X Get Y discount: £40 of one-off items
 * (Subscribe & save lines don't count), then ONE of 33 travel-size variants is
 * free. The shopper picks it; nothing is ever added for them.
 *
 * What it does, from the cart's own numbers (Shopify is the judge: a line is
 * "free" only when the cart shows the automatic discount on it):
 *  - Delivery bar ([data-cart-shipping-bar], drawer and /cart): one line for
 *    both goals, "£6 to free delivery, £16 to a free travel size"; the fill
 *    runs to £40 with a tick at £30. Any other sentence cart.js writes
 *    (codes, Subscribe & save, Inner Circle) keeps its words and gains
 *    " · £16 to a free travel size".
 *  - A box under the bar: the picker at £40+ ("You've earned a free travel
 *    size. Choose yours"), "no longer free" when the basket drops under £40,
 *    and the EARLY20 line (EARLY20 doesn't stack with the gift).
 *  - The gift line says "Free travel size" and its price reads "Free".
 *  - Cart attribute offer = TRAVEL40 while a free travel size is in the basket
 *    (shows on the order under Additional details), cleared when it goes.
 *  - On /collections/free-travel-size: the status line under the title.
 *
 * Counting rule (C.basis, default 'post'): the £40 is the one-off lines' own
 * prices after LINE-level codes. Tested 4 Nov 2026: The Conditioner 1 L
 * (£46.95) + a travel size + FIRST15 (an order-level code, basket £39.91)
 * still got the gift, so order-level codes don't count against the £40.
 * EARLY20 (line-level, doesn't stack) takes 20% off the travel size instead.
 * Vanilla ES5-style IIFE, no dependencies. Safe to include twice.
 */
(function () {
  'use strict';
  var C = window.TC_GIFT40;
  var TC = (window.TheColor = window.TheColor || {});
  if (!C || TC.Gift40) return;
  TC.Gift40 = { version: '2026-11-04' };

  var END = C.end * 1000;
  var MIN = C.min || 4000;
  var DEL = C.deliveryMin || 3000;
  var URL = C.url || '/collections/free-travel-size';
  var IDS = (C.ids || []).map(Number);
  var NO_STACK = (C.noStack || ['EARLY20']).map(function (c) { return String(c).toUpperCase(); });
  var BASIS = C.basis || 'post';

  function strip() {
    document.querySelectorAll('[data-tc-g40]').forEach(function (n) { n.remove(); });
    document.querySelectorAll('[data-tc-g40-line]').forEach(function (n) { n.removeAttribute('data-tc-g40-line'); });
  }
  if (Date.now() >= END) { strip(); return; }
  var left = END - Date.now();
  if (left < 2147483647) setTimeout(function () { dead = true; strip(); }, left);
  var dead = false;

  /* ---------- helpers ---------- */
  function money(p) {
    var v = Math.max(0, Math.ceil(p)) / 100;
    return '£' + (Math.round(v * 100) % 100 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function strong(t) { return el('strong', null, t); }
  function put(node, parts) {
    node.textContent = '';
    parts.forEach(function (x) { node.appendChild(typeof x === 'string' ? document.createTextNode(x) : x); });
  }
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function shortName(t) { return String(t || '').replace(/^Paul Mitchell\s+/i, '').replace(/\s*\(Original\)$/i, ''); }

  /* ---------- the cart, read the way checkout reads it ---------- */
  function isGiftVariant(i) { return i && !i.selling_plan_allocation && IDS.indexOf(Number(i.variant_id)) > -1; }
  function autoOff(i) {
    var a = 0;
    /* The cart reports the gift with an EMPTY type (tested 4 Nov 2026: type '',
       title "Free travel size (orders of £40+)"); codes say 'discount_code'. */
    (i.line_level_discount_allocations || []).forEach(function (d) {
      var app = d && d.discount_application;
      if (!app || app.type === 'discount_code' || app.type === 'manual') return;
      a += Number(d.amount) || 0;
    });
    return a;
  }
  function read(cart) {
    var s = { count: 0, pre: 0, post: 0, subs: false, gifts: [], free: null, freeUnits: 0, codes: [], noStack: null, total: Number(cart && cart.total_price) || 0 };
    ((cart && cart.items) || []).forEach(function (i, n) {
      if (!i) return;
      i._line = n + 1;
      s.count += i.quantity;
      if (i.selling_plan_allocation) { s.subs = true; return; }
      if (i.gift_card) return;
      if (isGiftVariant(i)) {
        s.gifts.push(i);
        var off = autoOff(i);
        if (!s.free && off > 0 && off >= i.original_price - 1) { s.free = i; s.freeUnits = Math.round(off / Math.max(1, i.original_price)); }
        return;
      }
      s.pre += Number(i.original_line_price) || 0;
      s.post += Number(i.final_line_price) || 0;
    });
    s.codes = ((cart && cart.discount_codes) || []).filter(function (c) { return c && c.code; });
    s.noStack = s.codes.filter(function (c) { return c.applicable && NO_STACK.indexOf(String(c.code).toUpperCase()) > -1; })[0] || null;
    s.other = s.codes.filter(function (c) { return NO_STACK.indexOf(String(c.code).toUpperCase()) === -1; })[0] || null;
    s.basis = BASIS === 'pre' ? s.pre : s.post;
    var keep = s.pre > 0 ? s.post / s.pre : 1;
    if (!(keep > 0.05)) keep = 1;
    s.gap = MIN - s.basis;
    s.shelfGap = s.gap > 0 ? Math.ceil(s.gap / (BASIS === 'pre' ? 1 : keep)) : 0;
    if (s.count === 0) s.kind = 'empty';
    else if (s.free) s.kind = 'free';
    else if (s.noStack) s.kind = 'nostack';
    else if (s.gifts.length) s.kind = s.gap > 0 ? 'short' : 'pending';
    else s.kind = s.gap > 0 ? 'need' : 'earned';
    /* "No longer free": this travel size was free earlier in the visit. */
    if (s.free) store.set('tc_g40_was', String(s.free.variant_id));
    s.wasFree = s.kind === 'short' && s.gifts.some(function (g) { return store.get('tc_g40_was') === String(g.variant_id); });
    return s;
  }

  /* ---------- styles (once) ---------- */
  function css() {
    if (document.getElementById('tc-g40-css')) return;
    var st = el('style');
    st.id = 'tc-g40-css';
    st.setAttribute('data-tc-g40', '');
    st.textContent = [
      '.tc-g40-box{margin:2px 0 6px;padding:0;background:none;border:0;font-size:.8125rem;line-height:1.45;color:var(--color-primary,#3C3028)}',
      '.tc-g40-box[hidden]{display:none}',
      '.tc-cart-drawer__shipping .tc-g40-box{text-align:center}',
      '.tc-g40-box p{margin:0}',
      '.tc-g40-box strong{font-weight:600}',
      '.tc-g40-act{display:inline-block;margin-left:.25rem;padding:.25rem 0;background:none;border:0;font:inherit;font-weight:600;color:var(--color-accent-text,#93654E);text-decoration:underline;text-underline-offset:2px;cursor:pointer}',
      '.tc-g40-act[aria-disabled="true"]{opacity:.6;cursor:progress}',
      '.tc-g40-all{display:inline;white-space:nowrap;font-weight:500;color:var(--color-accent-text,#93654E);text-decoration:underline;text-underline-offset:2px}',
      '.tc-g40-free{display:inline-block;margin:.125rem 0;padding:.125rem .4375rem;border-radius:2px;background:#1b1310;color:#f1d3c0;font-size:.625rem;font-weight:600;letter-spacing:.14em;text-transform:uppercase}',
      '.tc-g40-price{font-weight:700;color:var(--color-primary,#3C3028)}',
      '.tc-g40-mark{position:absolute;top:-2px;bottom:-2px;width:2px;background:rgba(60,48,40,.45);border-radius:1px;pointer-events:none}',
      '[data-cart-shipping-bar] .tc-cart-drawer__shipping-bar,[data-cart-shipping-bar] [class*="shipping-track"],[data-cart-shipping-bar] [class*="__shipping-progress"]{position:relative}',
      '.tc-g40-status{margin:.5rem 0 0;font-size:.875rem;font-weight:600;color:var(--color-accent-text,#93654E)}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ---------- delivery bar: one line, both goals ---------- */
  var writing = false;
  function simpleDelivery(cart, s) {
    return s.total < DEL && !s.codes.length && !s.subs && !document.querySelector('[data-inner-circle-min]');
  }
  function clause(s) {
    if (s.kind === 'need') {
      return ['Spend ', strong(money(s.shelfGap)), s.subs ? ' more on one-off items for a free travel size.' : ' more for a free travel size.'];
    }
    /* 'short' and 'earned' are said once, in the box under the bar. */
    if (s.kind === 'free') return [strong('Your free travel size is in.')];
    return null;
  }
  function decorateBar(bar, cart, s) {
    var msg = bar.querySelector('[data-shipping-text]');
    if (!msg) return;
    writing = true;
    try {
      msg.querySelectorAll('[data-tc-g40-clause]').forEach(function (n) { n.remove(); });
      var fill = bar.querySelector('[data-shipping-fill]');
      var track = fill ? fill.parentNode : null;
      var mark = track ? track.querySelector('.tc-g40-mark') : null;
      if (mark) mark.remove();
      var giftOpen = s.kind === 'need' || s.kind === 'short';
      if (giftOpen && simpleDelivery(cart, s)) {
        /* Owner's wording: "£6 to free delivery, £16 to a free travel size". */
        put(msg, [strong(money(DEL - s.total)), ' to free delivery, ', strong(money(s.shelfGap)), s.kind === 'short' ? ' more and your travel size is free' : ' to a free travel size']);
        msg.setAttribute('data-tc-g40-msg', '1');
        if (fill) fill.style.width = Math.min(100, (s.basis / MIN) * 100) + '%';
        if (track) {
          var m = el('i', 'tc-g40-mark');
          m.setAttribute('data-tc-g40', '');
          m.setAttribute('aria-hidden', 'true');
          m.style.left = Math.round((DEL / MIN) * 100) + '%';
          track.appendChild(m);
        }
      } else {
        var c = clause(s);
        if (c) {
          /* The message can be a flex row (the success tick): keep cart.js's
             words and ours in ONE inline wrapper so they read as one line. */
          var wrap = msg.querySelector(':scope > [data-tc-g40-wrap]');
          if (!wrap) {
            wrap = el('span');
            wrap.setAttribute('data-tc-g40-wrap', '');
            while (msg.firstChild) wrap.appendChild(msg.firstChild);
            msg.appendChild(wrap);
          }
          var said = wrap.textContent.replace(/\s+$/, '');
          var span = el('span');
          span.setAttribute('data-tc-g40-clause', '');
          span.setAttribute('data-tc-g40', '');
          span.appendChild(document.createTextNode(/[.!]$/.test(said) ? ' ' : '. '));
          c.forEach(function (x) { span.appendChild(typeof x === 'string' ? document.createTextNode(x) : x); });
          wrap.appendChild(span);
        }
        msg.setAttribute('data-tc-g40-msg', '1');
        /* The fill stays cart.js's (delivery): "You've unlocked free delivery"
           must never sit over a half-full bar. */
      }
    } finally { writing = false; }
  }

  /* ---------- the box under the bar ---------- */
  function busy(btn, on) {
    if (on) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('data-busy', '1'); }
    else { btn.removeAttribute('aria-disabled'); btn.removeAttribute('data-busy'); }
  }
  function removeGift(s, btn) {
    var g = s.gifts[s.gifts.length - 1];
    if (!g || !TC.Cart || !TC.Cart.updateQuantity || btn.getAttribute('data-busy')) return;
    busy(btn, true);
    Promise.resolve(TC.Cart.updateQuantity(g._line, Math.max(0, g.quantity - 1), g.key))
      .catch(function () {})
      .then(function () { busy(btn, false); });
  }
  function actBtn(label, fn) {
    var b = el('button', 'tc-g40-act', label);
    b.type = 'button';
    b.addEventListener('click', function () { fn(b); });
    return b;
  }
  /* Owner, 4 Nov 2026 22:00: "just a simple link for them to choose" (the tile
     row crowded the basket). One line, one link, nothing that moves the lines. */
  function picker(box) {
    var p = el('p');
    put(p, [strong('A travel size is on us.'), ' ']);
    var a = el('a', 'tc-g40-all', 'Choose yours \u2192');
    a.href = URL;
    p.appendChild(a);
    box.appendChild(p);
  }
  function fillBox(box, s) {
    var key = s.kind + '|' + (s.kind === 'short' || s.kind === 'pending' || s.kind === 'nostack' ? s.shelfGap + '|' + (s.noStack ? s.noStack.code : '') + '|' + (s.other ? s.other.code : '') + '|' + s.wasFree : '');
    if (box.getAttribute('data-key') === key) return;
    box.setAttribute('data-key', key);
    box.textContent = '';
    box.hidden = false;
    if (s.kind === 'earned') { picker(box); return; }
    var p = el('p');
    if (s.kind === 'nostack') {
      var code = String(s.noStack.code).toUpperCase();
      /* Owner's line, 4 Nov 2026 (EARLY20 takes 20% off the travel size too). */
      put(p, [strong(code), ' takes 20% off everything in your basket, including travel sizes. It can’t be used with the free travel size.']);
    } else if (s.kind === 'short') {
      put(p, s.wasFree
        ? [strong('Your travel size is no longer free.'), ' Add ', strong(money(s.shelfGap)), ' more, or ']
        : ['Add ', strong(money(s.shelfGap)), ' more of other products and your travel size is free, or ']);
      p.appendChild(actBtn('remove it', function (b) { removeGift(s, b); }));
      if (s.subs) p.appendChild(document.createTextNode(' Subscribe & save items don’t count towards the £40.'));
    } else if (s.kind === 'pending' && s.other) {
      put(p, [strong(String(s.other.code).toUpperCase()), ' can’t be used with the free travel size.']);
      p.appendChild(actBtn('Remove the travel size', function (b) { removeGift(s, b); }));
    } else {
      box.hidden = true;
      return;
    }
    box.appendChild(p);
  }
  /* Round 3: the gift line lives INSIDE the delivery strip, as its second line
     (same type, same alignment), not as a separate box under it. */
  function ensureBox(bar) {
    var nx = bar.querySelector('[data-tc-g40-box]');
    if (nx) return nx;
    var box = el('div', 'tc-g40-box');
    box.setAttribute('data-tc-g40', '');
    box.setAttribute('data-tc-g40-box', '');
    box.setAttribute('aria-live', 'polite');
    box.hidden = true;
    var msg = bar.querySelector('[data-shipping-text]');
    if (msg) msg.insertAdjacentElement('afterend', box); else bar.insertBefore(box, bar.firstChild);
    return box;
  }

  /* ---------- the gift line ---------- */
  function decorateLines(s) {
    document.querySelectorAll('[data-cart-item][data-tc-g40-line]').forEach(function (li) {
      if (!s.free || li.getAttribute('data-key') !== s.free.key) {
        li.removeAttribute('data-tc-g40-line');
        li.querySelectorAll('[data-tc-g40]').forEach(function (n) { n.remove(); });
      }
    });
    if (!s.free) return;
    var key = s.free.key;
    document.querySelectorAll('[data-cart-item]').forEach(function (li) {
      if (li.getAttribute('data-key') !== key) return;
      li.setAttribute('data-tc-g40-line', '');
      if (!li.querySelector('.tc-g40-free')) {
        var title = li.querySelector('.tc-cart-drawer__item-title, .tc-cart-main__item-title');
        var tag = el('span', 'tc-g40-free', s.free.quantity > 1 ? '1 free travel size' : 'Free travel size');
        tag.setAttribute('data-tc-g40', '');
        if (title) title.insertAdjacentElement('afterend', tag);
      }
      if (s.free.final_line_price === 0) {
        li.querySelectorAll('.tc-cart-drawer__item-price .tc-price__sale, .tc-cart-drawer__item-price > span:only-child, .tc-cart-main__line-price').forEach(function (pr) {
          if (pr.getAttribute('data-tc-g40-was') == null) pr.setAttribute('data-tc-g40-was', pr.textContent);
          pr.textContent = 'Free';
          pr.classList.add('tc-g40-price');
        });
      }
    });
  }

  /* ---------- order marker (counted on Monday) ---------- */
  var marking = false;
  function mark(cart, s) {
    var want = s.free ? 'TRAVEL40' : '';
    var have = (cart && cart.attributes && cart.attributes.offer) || '';
    if (want === have || marking) return;
    marking = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { offer: want } })
    }).then(function () {
      cart.attributes = cart.attributes || {};
      cart.attributes.offer = want;
    }).catch(function () {}).then(function () { marking = false; });
  }

  /* ---------- collection page status ---------- */
  function status(s) {
    document.querySelectorAll('[data-tc-g40-status]').forEach(function (n) {
      var parts;
      if (s.kind === 'free') parts = ['Your travel size is in your basket, with our compliments.'];
      else if (s.kind === 'earned') parts = ['Your basket qualifies: choose one below and it\u2019s on us.'];
      else if (s.kind === 'nostack') parts = [String(s.noStack.code).toUpperCase() + ' is on your basket, and it can\u2019t be used with the free travel size.'];
      else if (s.kind === 'need' || s.kind === 'short') parts = [money(s.shelfGap) + ' more on other products and a travel size is on us.'];
      else parts = [];
      put(n, parts);
    });
  }

  /* ---------- run ---------- */
  var last = null;
  function apply(cart) {
    if (dead) return;
    if (cart) last = cart;
    cart = last;
    if (!cart) return;
    css();
    var s = read(cart);
    document.querySelectorAll('[data-cart-shipping-bar]').forEach(function (bar) {
      decorateBar(bar, cart, s);
      var box = ensureBox(bar);
      if (s.kind === 'empty') { box.hidden = true; box.removeAttribute('data-key'); }
      else fillBox(box, s);
    });
    decorateLines(s);
    status(s);
    mark(cart, s);
    /* Our own writes above must not wake the observer below (it would loop). */
    if (mo) mo.takeRecords();
  }
  TC.Gift40.apply = apply;

  document.addEventListener('cart:updated', function (e) { apply(e && e.detail && e.detail.cart); });

  /* cart.js rewrites the bar on every repaint and /cart swaps its HTML: put the
     gift back whenever its words or box go missing. */
  var queued = false;
  function check() {
    queued = false;
    if (!last || dead) return;
    var need = false;
    document.querySelectorAll('[data-cart-shipping-bar]').forEach(function (bar) {
      var msg = bar.querySelector('[data-shipping-text]');
      if (!bar.querySelector('[data-tc-g40-box]')) need = true;
      if (msg && !msg.hasAttribute('data-tc-g40-msg')) need = true;
    });
    if (last && last.items && last.items.length) {
      var s = read(last);
      if (s.free && !document.querySelector('[data-cart-item][data-tc-g40-line]')) need = true;
    }
    if (need) apply(null);
  }
  var mo = new MutationObserver(function (list) {
    if (writing || queued) return;
    for (var k = 0; k < list.length; k++) {
      var t = list[k].target;
      if (t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-shipping-text') && list[k].type === 'childList') t.removeAttribute('data-tc-g40-msg');
    }
    queued = true;
    (window.requestAnimationFrame || setTimeout)(check);
  });

  function start() {
    if (dead) return;
    mo.observe(document.body, { childList: true, subtree: true });
    var ui = TC.CartUI;
    if (ui && ui.repaint && !ui.__g40) {
      var orig = ui.repaint;
      ui.repaint = function (cart) {
        var r = orig.apply(this, arguments);
        apply(cart || null);
        return r;
      };
      ui.__g40 = true;
    }
    if (TC.Cart && TC.Cart.current) {
      Promise.resolve(TC.Cart.current()).then(function (c) { if (c) apply(c); }).catch(function () {});
    } else if (document.querySelector('[data-tc-g40-status]')) {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(apply).catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
